<!--
  - Copyright (c) 2019 Eva Novotná, Juraj Šimon
  -->

<template>
  <swiper-slide>
    <a href="#what-i-do" v-smooth-scroll="{ duration: 800 }">
      <div :class="{ slide: true, [backgroundImageClass]: true }">
        <div
          :class="{
            'slide-label': true,
            'slide-label-top': !swapStyles,
            'slide-label-bottom': swapStyles,
            'is-uppercase': true
          }"
        >
          {{ topLabel }}
        </div>
        <div
          :class="{
            'slide-label': true,
            'slide-label-bottom': !swapStyles,
            'slide-label-top': swapStyles,
            'is-uppercase': true
          }"
        >
          {{ bottomLabel }}
        </div>
      </div>
    </a>
  </swiper-slide>
</template>
<script>
export default {
  props: {
    backgroundImageClass: {
      type: String,
      required: true
    },
    topLabel: {
      type: String,
      required: true
    },
    bottomLabel: {
      type: String,
      required: true
    },
    swapStyles: {
      type: Boolean,
      default: false
    }
  }
};
</script>
